import {
    AdDemand,
    AdRefreshOptions,
    SparkleAdOptions,
} from "@foundation/sparkle";

import { AdKey } from "./ads/adLogic";

const AD_REFRESH_RATES: Record<AdDemand, number> = {
    // Should have no refresh at extra low; 0 evaluates to false and will not run sparkle.useAdRefresh()
    "extra-low": 0,
    low: 90000,
    medium: 60000,
    high: 45000,
};

export const getRefreshInterval = (adDemand: AdDemand): number =>
    AD_REFRESH_RATES[adDemand] ?? AD_REFRESH_RATES.low;

export const getAdRefreshOptions = (
    customRefreshOptions: Record<AdKey, AdRefreshOptions> | undefined,
    adOptions: SparkleAdOptions,
    adType: AdKey
) => {
    const refreshInterval =
        customRefreshOptions?.[adType]?.refreshInterval ??
        adOptions.refreshOptions?.refreshInterval ??
        AD_REFRESH_RATES.low;
    return {
        refreshOptions: {
            refreshInterval,
        },
    };
};
